<template>
    <div class="ku-coupon-add">
        <div class="t1" v-if="check === 1">
            <div class="add">恭喜获得新人优惠券</div>
            <div class="s2">
                <div class="c1">￥</div>
                <div class="c2">{{ money }}</div>
            </div>
        </div>
        <div class="t2" v-if="check === 0">领取失败</div>

        <div class="open">
<!--            <div class="title">去下单</div>-->

<!--            <van-button type="info" @click="onPath(1)">堂食/外带</van-button>-->
<!--            <van-button type="info" @click="onPath(2)">外卖</van-button>-->

            <img class="qrcode" src="../../assets/coupon.png" style="object-fit: cover" alt="qrcode">
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {Field, Button, Notify, Cell, CellGroup, Icon, Dialog} from 'vant';
import {VueJsonp} from 'vue-jsonp';
import {UrlSearch} from "@/utils/fu";
import {setCookie} from "@/utils/auth";

Vue.use(Field).use(Button).use(Notify).use(Cell).use(CellGroup).use(Icon).use(Dialog);
Vue.use(VueJsonp);

export default {
    data() {
        return {
            id: 0,
            dre_code: '',
            check: -1,
            money: 0,
        };
    },
    mounted() {
        let href = new UrlSearch();
        this.id = href.id
        this.dre_code = href.dre_code

        if (this.id) {
            this.sendDre();
        }

    },
    methods: {
        sendDre() {
            let ve = this
            this.$API.sendDre({id: ve.id, code: ve.dre_code}).then(res => {
                return res.data
            }).then(res => {
                if (res.data.err) {
                    ve.check = 0
                    Notify({ type: 'danger', message: res.data.err });
                } else {
                    ve.check = 1
                    ve.money = res.data.money
                }
            })
        },
        onPath(type) {
            console.log(type)
            setCookie('coType', type)
            this.$router.push({
                path: '/'
            })
        },
    },
};
</script>

<style lang="less" scoped>
.ku-coupon-add {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #baa58c;

    .t1 {
        .add {
            font-size: 60px;
            line-height: 120px;
            color: #000;
            margin-top: 30px;
            font-family: 'KaiTi', serif;
            font-weight: bold;

            span {
                color: #FFF100;
            }
        }

        .s2 {
            text-align: center;
            color: white;

            .c1 {
                font-size: 40px;
                display: inline-block;
                vertical-align: top;
                padding-top: 30px;
            }

            .c2 {
                font-size: 190px;
                display: inline-block;
                vertical-align: top;
            }
        }
    }

    .t2 {
        font-size: 80px;
        font-family: 'KaiTi', serif;
        color: #FFFF00;
        display: inline-block;
        margin: 120px auto;
        border: 1px solid white;
        padding: 20px 30px;
    }

    .open {
        padding-top: 60px;
        .title {
            font-size: 40px;
            font-weight: bold;
            color: black;
            padding: 50px 20px 30px 20px;
        }
        .van-button {
            width: 300px;
            height: 80px;
            display: block;
            margin: 0 auto 30px;
            background: white;
            border-radius: 10px;
            border-color: white;
            color: black;
            font-size: 42px;
            font-weight: bold;
            &:nth-child(2) {
                color: #E45A24;
            }
        }
        .s2 {
            color: white;
            font-size: 30px;
            padding-bottom: 10px;
        }
        .qrcode {
            width: 300px;
        }
        .s3 {
            color: white;
            font-size: 32px;
            padding-top: 10px;
            font-family: 'KaiTi', serif;
        }
    }
}
</style>
